import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPersonLock32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconPersonLock32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14 8a3 3 0 0 1 3 3h2a5 5 0 1 0-8.334 3.726A8 8 0 0 0 6 22v4h7v-2H8v-2a6 6 0 0 1 5-5.917v-2.254A3.001 3.001 0 0 1 14 8m6 6a2 2 0 0 1 2 2h-4a2 2 0 0 1 2-2m-4 2.535V16a4 4 0 0 1 8 0v.535c1.196.692 2 1.984 2 3.465v2a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4v-2c0-1.48.804-2.773 2-3.465M18 18a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPersonLock32);
